import { render, staticRenderFns } from "./SettingFormItem.vue?vue&type=template&id=5d581c04&lang=html&"
import script from "./SettingFormItem.vue?vue&type=script&lang=js&"
export * from "./SettingFormItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingFormItem.vue?vue&type=style&index=0&id=5d581c04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports